var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.354.646a.5.5 0 0 1 0 .708l-5.5 5.5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L3.5 5.793 8.646.646a.5.5 0 0 1 .708 0Z",
    fill: "currentColor"
  })));
};

export { SvgCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjM1MzU1IDAuNjQ2NDQ3QzkuNTQ4ODIgMC44NDE3MDkgOS41NDg4MiAxLjE1ODI5IDkuMzUzNTUgMS4zNTM1NUwzLjg1MzU1IDYuODUzNTVDMy42NTgyOSA3LjA0ODgyIDMuMzQxNzEgNy4wNDg4MiAzLjE0NjQ1IDYuODUzNTVMMC42NDY0NDcgNC4zNTM1NUMwLjQ1MTE4NCA0LjE1ODI5IDAuNDUxMTg0IDMuODQxNzEgMC42NDY0NDcgMy42NDY0NUMwLjg0MTcwOSAzLjQ1MTE4IDEuMTU4MjkgMy40NTExOCAxLjM1MzU1IDMuNjQ2NDVMMy41IDUuNzkyODlMOC42NDY0NSAwLjY0NjQ0N0M4Ljg0MTcxIDAuNDUxMTg0IDkuMTU4MjkgMC40NTExODQgOS4zNTM1NSAwLjY0NjQ0N1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";